let TZ = "America/Chicago";
export const setTimezone = (tz) => { if (tz) TZ = tz; };

export function fmtDate(d) {
  if (!d) return "";
  const [y, m, day] = d.split("-").map(Number);
  return new Date(Date.UTC(y, m - 1, day)).toLocaleDateString("en-US", { timeZone: "UTC", month: "short", day: "numeric", year: "numeric" });
}

export function fmtDateLong(d) {
  if (!d) return "";
  const [y, m, day] = d.split("-").map(Number);
  return new Date(Date.UTC(y, m - 1, day)).toLocaleDateString("en-US", { timeZone: "UTC", weekday: "long", month: "long", day: "numeric", year: "numeric" });
}

export function fmtStamp(iso) {
  if (!iso) return "—";
  return new Date(iso).toLocaleString("en-US", { timeZone: TZ, month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit" });
}

export function fmtNum(v) {
  const n = Number(v || 0);
  return Number.isInteger(n) ? n.toLocaleString("en-US") : n.toLocaleString("en-US", { maximumFractionDigits: 2 });
}

export const fmtPct = (v) => (v == null ? "—" : `${Math.round(v * 100)}%`);

// Keep only digits and one decimal point; phones may send "," as the decimal key.
export const cleanNum = (v) => String(v ?? "").replace(/,/g, ".").replace(/[^0-9.]/g, "").replace(/(\..*)\./g, "$1");

export function addDays(d, n) {
  const [y, m, day] = d.split("-").map(Number);
  const dt = new Date(Date.UTC(y, m - 1, day + n));
  return dt.toISOString().slice(0, 10);
}

export function weekStart(d) {
  const [y, m, day] = d.split("-").map(Number);
  const dow = new Date(Date.UTC(y, m - 1, day)).getUTCDay();
  return addDays(d, -((dow + 6) % 7));
}

export function hoursBetween(start, end) {
  if (!start || !end) return "";
  const [sh, sm] = start.split(":").map(Number);
  const [eh, em] = end.split(":").map(Number);
  let mins = eh * 60 + em - (sh * 60 + sm);
  if (mins < 0) mins += 24 * 60;
  return Math.round((mins / 60) * 100) / 100;
}

export const STATUS_LABEL = { draft: "Draft", submitted: "Submitted", edited: "Edited", archived: "Archived", new: "Not saved" };
